import React from 'react';
interface HeroButtonProps {
  href: string;
  text: string;
  primary: boolean;
  icon: React.ReactNode;
  secondaryIcon: React.ReactNode;
  /**
   * Optional data-id for testing purposes
   */
  'data-id'?: string;
}
export function HeroButton({
  href,
  text,
  primary,
  icon,
  secondaryIcon,
  'data-id': dataId
}: HeroButtonProps) {
  return <a href={href} className={`group flex flex-row flex-nowrap items-center justify-center w-full h-14 relative overflow-hidden rounded-xl cursor-pointer gap-3 py-2 pl-6 pr-2 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] ${primary ? 'bg-[#3ab795] hover:bg-[#2d9575] shadow-[0_4px_16px_rgba(58,183,149,0.3)] hover:shadow-[0_8px_24px_rgba(58,183,149,0.4)]' : 'bg-white hover:bg-gray-50 border border-gray-200 hover:border-gray-300 shadow-[0_2px_8px_rgba(0,0,0,0.06)]'}`} data-id="element-1549">
      <div className="relative flex flex-col flex-shrink-0 justify-center items-center whitespace-nowrap flex-grow-0 flex-basis-auto h-[28px] transform-none" data-id="element-1550">
        <p className={`font-medium text-center text-[16px] leading-[28px] m-0 p-0 transition-colors duration-300 ${primary ? 'text-white' : 'text-[#0a0a0a] group-hover:text-black'}`} data-id="element-1551">
          {text}
        </p>
      </div>
      <div className={`flex flex-row flex-nowrap flex-grow-0 flex-shrink-0 flex-basis-auto items-center justify-center w-10 h-10 relative overflow-hidden aspect-square rounded-full p-0 transition-all duration-300 group-hover:scale-110 ${primary ? 'bg-white' : 'bg-[#f6f6f6] group-hover:bg-[#e8e8e8]'}`} data-id="element-1552">
        <div className="flex flex-row flex-nowrap flex-grow-0 flex-shrink-0 flex-basis-auto items-center justify-center w-[20px] h-[20px] absolute overflow-visible top-[50%] left-[50%] transform-gpu -translate-x-[50%] -translate-y-[50%] transition-all duration-300 group-hover:translate-x-[20px] group-hover:opacity-0" data-id="element-1553">
          <div aria-hidden="true" className="relative flex-grow-0 flex-shrink-0 flex-basis-auto w-[20px] h-[20px] bg-transparent" data-id="element-1554">
            <div className={`w-[20px] h-[20px] aspect-auto ${primary ? 'text-[#3ab795]' : 'text-[#0a0a0a]'}`} data-id="element-1555">
              {icon}
            </div>
          </div>
        </div>
        <div className="flex flex-row flex-nowrap flex-grow-0 flex-shrink-0 flex-basis-auto items-center justify-center w-[20px] h-[20px] absolute top-[50%] left-[-20px] overflow-visible transform-gpu -translate-y-[50%] transition-all duration-300 group-hover:translate-x-[30px]" data-id="element-1556">
          <div aria-hidden="true" className="relative flex-grow-0 flex-shrink-0 flex-basis-auto w-[20px] h-[20px] bg-transparent" data-id="element-1557">
            <div className={`w-[20px] h-[20px] aspect-auto ${primary ? 'text-[#3ab795]' : 'text-[#0a0a0a]'}`} data-id="element-1558">
              {secondaryIcon}
            </div>
          </div>
        </div>
      </div>
    </a>;
}